import { render, staticRenderFns } from "./JsonKeyValue.vue?vue&type=template&id=a54d71fc&"
import script from "./JsonKeyValue.vue?vue&type=script&lang=js&"
export * from "./JsonKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports